<!-- 货场信息详情页 -->
<template>
  <div class="app-container order-detail-wrap">
    <div class="module-wrap">
      <el-descriptions title="基础信息" class="common-description-border">
        <el-descriptions-item label="货场编码">{{
          (formData.goodsYardInfoResp &&
            formData.goodsYardInfoResp.goodsYardCode) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="分公司">{{
          (formData.goodsYardInfoResp && formData.goodsYardInfoResp.orgName) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="货场主姓名">{{
          (formData.goodsYardInfoResp &&
            formData.goodsYardInfoResp.goodsYardUser) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="货场联系电话">{{
          (formData.goodsYardInfoResp &&
            formData.goodsYardInfoResp.goodsYardPhone) ||
          "--"
        }}
          <span v-if="formData.goodsYardInfoResp.goodsYardPhone">
            <img v-if="!dataVisible.goodsYardPhone" src="@/assets/eye-close.png" @click="toggleVisibility('goodsYardPhone')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('goodsYardPhone')" />
          </span>
      </el-descriptions-item>
        <el-descriptions-item label="更新时间">
          {{ formData.goodsYardInfoResp.updateTime }}
        </el-descriptions-item>
        <el-descriptions-item label="提交时间">
          {{
            formData.goodsYardInfoResp && formData.goodsYardInfoResp.submitTime
          }}
        </el-descriptions-item>
        <el-descriptions-item label="货场地区">{{
          (formData.goodsYardInfoResp &&
            `${formData.goodsYardInfoResp.provinceName || ""}${
              formData.goodsYardInfoResp.cityName || ""
            }${formData.goodsYardInfoResp.districtName || ""}${
              formData.goodsYardInfoResp.townName || ""
            }`) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="货场详细地址">{{
          (formData.goodsYardInfoResp && formData.goodsYardInfoResp.address) ||
          "--"
        }}
          <span v-if="formData.goodsYardInfoResp.address">
            <img v-if="!dataVisible.address" src="@/assets/eye-close.png" @click="toggleVisibility('address')" />
            <img v-else src="@/assets/eye-open.png" @click="toggleVisibility('address')" />
          </span>
        </el-descriptions-item>
        <el-descriptions-item label="更新人">{{
          (formData.goodsYardInfoResp &&
            formData.goodsYardInfoResp.lastModifiedByName) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="提交人">{{
          (formData.goodsYardInfoResp &&
            formData.goodsYardInfoResp.createdByName) ||
          "--"
        }}</el-descriptions-item>
        <el-descriptions-item label="货场面积"
          >{{
            (formData.goodsYardInfoResp &&
              formData.goodsYardInfoResp.goodsYardSquare) ||
            "--"
          }}m²</el-descriptions-item
        >
        <el-descriptions-item label="月供货量"
          >{{
            (formData.goodsYardInfoResp && formData.goodsYardInfoResp.monthNum !== null && formData.goodsYardInfoResp.monthNum !== undefined)
              ? formData.goodsYardInfoResp.monthNum
              : "--"
          }}套</el-descriptions-item
        >
        <el-descriptions-item label="年供货量"
          >{{
            (formData.goodsYardInfoResp && formData.goodsYardInfoResp.yearNum !== null && formData.goodsYardInfoResp.yearNum !== undefined)
              ? formData.goodsYardInfoResp.yearNum
              : "--"
          }}套</el-descriptions-item
        >
        <el-descriptions-item label="经营情况">
          {{ businessCategoryDisplay }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="module-wrap">
      <el-descriptions title="走访信息" class="common-description-border">
        <el-descriptions-item label="走访时间">{{
          formData.goodsYardVisitResp.visitDate
        }}</el-descriptions-item>
        <el-descriptions-item label="货场库存(空调)"
          >{{
            (formData.goodsYardVisitResp &&
              formData.goodsYardVisitResp.goodsYardInventory) ||
            "--"
          }}套</el-descriptions-item
        >
        <el-descriptions-item label="货场回收价(单片空调)"
          >{{
            (formData.goodsYardVisitResp && formData.goodsYardVisitResp.singleAirconditionRecyclePrice !== null && formData.goodsYardVisitResp.singleAirconditionRecyclePrice !== undefined)
              ? formData.goodsYardVisitResp.singleAirconditionRecyclePrice
              : "--"
          }}元/KG</el-descriptions-item
        >
        <el-descriptions-item label="货场回收价(双片空调)"
          >{{
            (formData.goodsYardVisitResp && formData.goodsYardVisitResp.doubleAirconditionRecyclePrice !== null && formData.goodsYardVisitResp.doubleAirconditionRecyclePrice !== undefined)
              ? formData.goodsYardVisitResp.doubleAirconditionRecyclePrice
              : "--"
          }}元/KG</el-descriptions-item
        >
        <el-descriptions-item label="货场出货价(单片空调)"
          >{{
            (formData.goodsYardVisitResp && formData.goodsYardVisitResp.singleAirconditionSellPrice !== null && formData.goodsYardVisitResp.singleAirconditionSellPrice !== undefined)
              ? formData.goodsYardVisitResp.singleAirconditionSellPrice
              : "--"
          }}元/KG</el-descriptions-item
        >
        <el-descriptions-item label="货场出货价(双片空调)"
          >{{
            (formData.goodsYardVisitResp && formData.goodsYardVisitResp.doubleAirconditionSellPrice !== null && formData.goodsYardVisitResp.doubleAirconditionSellPrice !== undefined)
              ? formData.goodsYardVisitResp.doubleAirconditionSellPrice
              : "--"
          }}元/KG</el-descriptions-item
        >
        <el-descriptions-item label="最近一次供货时间" :span="12">{{
          formData.goodsYardVisitResp.latestSupplyDate
        }}</el-descriptions-item>
        <el-descriptions-item label="近期出货计划" :span="12">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formData.goodsYardVisitResp.latestShipmentPlan"
            placement="top-start"
          >
            <div class="item-style">
              {{
                (formData.goodsYardVisitResp &&
                  formData.goodsYardVisitResp.latestShipmentPlan) ||
                "--"
              }}
            </div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item label="合作模式" :span="12">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formData.goodsYardVisitResp.partnerMode"
            placement="top-start"
          >
            <div class="item-style">
              {{
                (formData.goodsYardVisitResp &&
                  formData.goodsYardVisitResp.partnerMode) ||
                "--"
              }}
            </div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item label="货源流向" :span="12">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formData.goodsYardVisitResp.sourceFlow"
            placement="top-start"
          >
            <div class="item-style">
              {{
                (formData.goodsYardVisitResp &&
                  formData.goodsYardVisitResp.sourceFlow) ||
                "--"
              }}
            </div>
          </el-tooltip>
        </el-descriptions-item>
        <el-descriptions-item label="合作供应商" :span="12">
          <el-tooltip
            class="item"
            effect="dark"
            :content="formData.goodsYardVisitResp.cooperativeSuppliers"
            placement="top-start"
          >
            <div class="item-style">
              {{
                (formData.goodsYardVisitResp &&
                  formData.goodsYardVisitResp.cooperativeSuppliers) ||
                "--"
              }}
            </div>
          </el-tooltip>
        </el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="module-wrap">
      <div class="sub-title">竞企信息</div>
      <div class="table">
        <el-table :data="formData.goodsYardCompetitorsResp">
          <el-table-column
            prop="competitorsName"
            label="竞企名称"
          >

          </el-table-column>
          <el-table-column
            prop="singleAirconditionRecyclePrice"
            label="收货价(单片空调)(元/KG)"
          ></el-table-column>
          <el-table-column
            prop="doubleAirconditionRecyclePrice"
            label="收货价(双片空调)(元/KG)"
          ></el-table-column>
        </el-table>
      </div>
      <div class="sub-title">更新记录</div>
      <div class="table">
        <el-table :data="formData.historyList">
          <el-table-column prop="lastModifiedByName" label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showHistory(scope.row.id)"
                >查看</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="lastModifiedByName"
            label="更新人"
          ></el-table-column>
          <el-table-column
            prop="updateTime"
            label="更新时间"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="bottom-wrap">
      <el-row class="row" justify="center" type="flex">
        <el-button type="" size="medium" @click="$router.go(-1)"
          >返回</el-button
        >
      </el-row>
    </div>
    <goods-yard-modal ref="goodsYardModal" />
  </div>
</template>

<script>
import { getYardInfo } from "@/api/goodsYard";
// import { orderStatusOption } from "./mixin.js";
import imageUpload from "@/components/Upload/ImageUpload";
import GoodsYardModal from "./components/GoodsYardModal.vue";
import mixin from "./mixin";

export default {
  name: "goodsYardDetail",
  mixins: [mixin],

  components: { imageUpload, GoodsYardModal },
  computed: {
    baseUrl() {
      return process.env.BASE_API;
    },
    businessCategoryDisplay() {
      const categories = this.formData.goodsYardInfoResp.businessCategory || [];
      return categories
        .map((category) => this.businessCategory[category] || category)
        .join(", ");
    },
  },
  data() {
    return {
      id: this.$route.query.id,

      formData: {
        //基础信息
        goodsYardInfoResp: {
          id: "", // string | null 主键 必需
          goodsYardCode: "", // string | null 货场编码 可选
          orgId: "", // string | null 机构 必需
          orgName: "", // string | null 机构名称 必需
          provinceName: "", // string | null 省份 可选
          provinceCode: "", // string | null 省份code 可选
          cityName: "", // string | null 城市 可选
          cityCode: "", // string | null 城市code 可选
          districtName: "", // string | null 区县 可选
          districtCode: "", // string | null 区县code 可选
          townName: "", // string | null 乡镇 可选
          townCode: "", // string | null 乡镇code 可选
          address: "", // string | null 详细地址 可选
          goodsYardUser: "", // string | null 货场主姓名 可选
          goodsYardPhone: "", // string | null 货场联系电话 可选
          goodsYardSquare: 0, // integer | null 货场面积 可选
          monthNum: 0, // integer | null 月供货量(空调) 可选
          yearNum: 0, // integer | null 年供货量(空调) 可选
          businessCategory: "", // string | null 经营品类 可选
          status: 0, // integer | null 状态，0-待提交，1-已提交 可选
          submitTime: "", // string | null 提交时间 可选
          latestRecord: 0, // integer | null 是否最新记录，0-否，1-是 可选
          createdByName: "", // string | null 创建人名 可选
          createdDate: {},
          lastModifiedDate: {},
        },
        //走访信息
        goodsYardVisitResp: {
          id: "", // string | null 主键 必需
          goodsYardId: "", // string | null 货场id 可选
          visitDate: "", // string | null 走访时间 可选
          goodsYardInventory: 0, // integer | null 货场库存（空调） 可选
          singleAirconditionRecyclePrice: 0.0, // number | null 货场回收价（单片空调） 可选
          doubleAirconditionRecyclePrice: 0.0, // number | null 货场回收价（双片空调） 可选
          singleAirconditionSellPrice: 0.0, // number | null 货场出货价（单片空调） 可选
          doubleAirconditionSellPrice: 0.0, // number | null 货场回收价（双片空调） 可选
          latestSupplyDate: "", // string | null 最近一次供货日期 可选
          latestShipmentPlan: "", // string | null 近期出货计划 可选
          partnerMode: "", // string | null 合作模式 可选
          sourceFlow: "", // string | null 货源流向 可选
          cooperativeSuppliers: "", // string | null 合作供应商 可选
        },
        //竞企列表
        goodsYardCompetitorsResp: [
          {
            id: "", // string | null 主键 必需
            goodsYardId: "", // string | null 货场id 可选
            competitorsId: "", // string | null 竞企id 可选
            competitorsName: "", // string | null 竞企名称 可选
            singleAirconditionRecyclePrice: 0, // number | null 竞企业回收价（单片空调） 可选
            doubleAirconditionRecyclePrice: 0, // number | null 竞企业回收价（双片空调） 可选
            orderNum: 0, // integer | null 编号 可选
          },
        ],
        //历史记录
        historyList: [
          {
            id: "", // string | null 主键 必需
            goodsYardCode: "", // string | null 货场编码 可选
            orgId: "", // string | null 机构 必需
            orgName: "", // string | null 机构名称 必需
            provinceName: "", // string | null 省份 可选
            provinceCode: "", // string | null 省份code 可选
            cityName: "", // string | null 城市 可选
            cityCode: "", // string | null 城市code 可选
            districtName: "", // string | null 区县 可选
            districtCode: "", // string | null 区县code 可选
            townName: "", // string | null 乡镇 可选
            townCode: "", // string | null 乡镇code 可选
            address: "", // string | null 详细地址 可选
            goodsYardUser: "", // string | null 货场主姓名 可选
            goodsYardPhone: "", // string | null 货场联系电话 可选
            goodsYardSquare: 0, // integer | null 货场面积 可选
            monthNum: 0, // integer | null 月供货量(空调) 可选
            yearNum: 0, // integer | null 年供货量(空调) 可选
            businessCategory: "", // string | null 经营品类 可选
            status: 0, // integer | null 状态，0-待提交，1-已提交 可选
            submitTime: "", // string | null 提交时间 可选
            latestRecord: 0, // integer | null 是否最新记录，0-否，1-是 可选
            createdByName: "", // string | null 创建人名 可选
            createdDate: "", // object (Instant) 创建时间 可选
            lastModifiedDate: "", // object (Instant) 更新时间 可选
            lastModifiedByName: "", // string | null 更新人名 可选
          },
        ],
      }, //货场详情对象
      productImageBase64: "",
      // orderStatusOption: orderStatusOption, //订单状态
      partnershipType: "", // 1: "子公司", 2: "合作商", 3: "总公司" ,
      competitiveEnterpriseInformation: [], //竞企列表
      updateList: [], //更新记录
      originData: {},
      address: {},
      goodsYardPhone: {},
      dataVisible: {
        goodsYardPhone: false,
        address: false,
      }
    };
  },

  filters: {},
  async created() {
    this.partnershipType = JSON.parse(localStorage.getItem("partnershipType"));
    if (this.id) {
      this.getDetail();
    }
  },
  methods: {
    //获取回收详情
    async getDetail() {
      let { statusCode, data, message } = await getYardInfo(this.id);

      if (statusCode == 200) {
        this.formData = data;
        this.originData= data.goodsYardInfoResp? {...data.goodsYardInfoResp} : {};

        // 根据 sensitizationCode 拆分数据
        if (data.desensitizationDtoList && Array.isArray(data.desensitizationDtoList)) {
          const phoneMappings = {
            address_address: 'address',
            goodsYardPhone_phone: 'goodsYardPhone',
          }

          data.desensitizationDtoList.forEach(item => {
            const targetProperty = phoneMappings[item.sensitizationCode]
            if (targetProperty) {
              this[targetProperty] = {
                sensitizationCode: item.sensitizationCode,
                message: item.message
              }
            }
          })
        }
      } else {
        this.$message.error(message);
      }
    },
    showHistory(id) {
      this.$refs.goodsYardModal.openModal(id);
    },

    getSourceOrigin(data) {
      return this.HttpService.post(`/autoapp-default-server-recovery/api/deSensitization/getSource`, data).then(res => {
        if (res.statusCode === 200) {
          return res.data
        }
      })
    },
    toggleVisibility(dataType) {
      // 切换显示状态
      this.dataVisible[dataType] = !this.dataVisible[dataType]

      // 根据不同类型处理显示逻辑
      switch (dataType) {
        case 'goodsYardPhone':
          if (this.dataVisible.goodsYardPhone && this.goodsYardPhone.message) {
            this.getSourceOrigin(this.goodsYardPhone).then(res => {
              this.$set(this.formData.goodsYardInfoResp, 'goodsYardPhone', res)
            })
          } else if (!this.dataVisible.goodsYardPhone) {
            // 还原为原始脱敏数据
            this.$set(this.formData.goodsYardInfoResp, 'goodsYardPhone', this.originData.goodsYardPhone)
          }
          break
        case 'address':
          if (this.dataVisible.address && this.address.message) {
            this.getSourceOrigin(this.address).then(res => {
              this.$set(this.formData.goodsYardInfoResp, 'address', res)
            })
          } else if (!this.dataVisible.address) {
            // 还原为原始脱敏数据
            this.$set(this.formData.goodsYardInfoResp, 'address', this.originData.address)
          }
          break
      }
    }
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/deep/ .el-descriptions-item__content {
  white-space: unset;
  overflow: hidden;
  text-overflow: ellipsis;
  // width: 90%;
}

.order-detail-wrap {
  .module-wrap {
    margin-bottom: 10px;
  }

  .sub-title {
    font-size: 16px;
    font-weight: bold;
    color: rgb(48, 49, 51);
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .image-style {
    width: 80px;
    height: 80px;
    margin-right: 20px;
  }

  .total-price {
    font-size: 12px;
    color: #606266;
    margin-top: 10px;
  }

  .footer-wrap {
    display: flex;
    justify-content: flex-end;
  }

  .downLoadLink {
    color: #1459c0;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/goodsYardDetail.vue